(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["bundle-picker"] && !Shopify.designMode) return;
  try {
    
  class BundlePicker extends HTMLElement {
    connectedCallback() {
      this.checkboxes = Array.from(this.querySelectorAll('input[type="checkbox"]'));
      this.totalEl = this.querySelector('[data-bundle-total]');
      this.addButton = this.querySelector('[data-bundle-add-all]');

      this.checkboxes.forEach((cb) => cb.addEventListener('change', this.updateTotal.bind(this)));
      if (this.addButton) this.addButton.addEventListener('click', this.addAll.bind(this));

      this.updateTotal();
    }

    updateTotal() {
      const totalCents = this.checkboxes
        .filter((cb) => cb.checked)
        .reduce((sum, cb) => sum + parseInt(cb.dataset.price || '0', 10), 0);
      if (this.totalEl && window.Shopify && window.Shopify.formatMoney) {
        this.totalEl.textContent = window.Shopify.formatMoney(totalCents);
      } else if (this.totalEl) {
        this.totalEl.textContent = (totalCents / 100).toFixed(2);
      }
    }

    async addAll() {
      const items = this.checkboxes
        .filter((cb) => cb.checked)
        .map((cb) => ({ id: cb.dataset.variantId, quantity: 1 }));

      if (items.length === 0) return;

      this.addButton.setAttribute('disabled', 'true');
      try {
        await fetch(window.routes.cart_add_url, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ items }),
        });
        document.dispatchEvent(new CustomEvent('cart:refresh'));
        window.location.href = window.routes.cart_url || '/cart';
      } finally {
        this.addButton.removeAttribute('disabled');
      }
    }
  }

  customElements.define('bundle-picker', BundlePicker);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cart-drawer"] && !Shopify.designMode) return;
  try {
    
    class CartDrawer extends HTMLElement {
      connectedCallback() {
        this.closers = this.querySelectorAll('[data-cart-drawer-close]');
        this.closers.forEach((el) => el.addEventListener('click', this.close.bind(this)));
        this.addEventListener('keyup', (event) => {
          if (event.code === 'Escape') this.close();
        });

        const cartIcon = document.getElementById('cart-icon-bubble');
        if (cartIcon) {
          cartIcon.addEventListener('click', (event) => {
            event.preventDefault();
            this.open();
          });
        }

        document.addEventListener('cart:refresh', this.refresh.bind(this));

        document.addEventListener('click', (event) => {
          const button = event.target.closest('[data-cart-quick-add]');
          if (!button) return;
          this.quickAdd(button);
        });
      }

      async quickAdd(button) {
        if (button.disabled) return;
        const variantId = button.dataset.variantId;
        if (!variantId) return;

        button.disabled = true;

        try {
          const response = await fetch(window.routes.cart_add_url, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
            body: JSON.stringify({ id: variantId, quantity: 1 })
          });
          const data = await response.json();

          if (data.status) {
            button.textContent = data.description || window.variantStrings.unavailable;
            return;
          }

          document.dispatchEvent(new CustomEvent('cart:refresh'));
        } catch (error) {
          button.disabled = false;
        }
      }

      open() {
        this.setAttribute('data-open', '');
        document.body.style.overflow = 'hidden';
      }

      close() {
        this.removeAttribute('data-open');
        document.body.style.overflow = '';
      }

      refresh() {
        fetch(`${window.location.origin}/?section_id=${this.dataset.sectionId}`)
          .then((res) => res.text())
          .then((html) => {
            const doc = new DOMParser().parseFromString(html, 'text/html');

            const newItems = doc.getElementById('CartDrawerItems');
            const currentItems = this.querySelector('#CartDrawerItems');
            if (newItems && currentItems) currentItems.innerHTML = newItems.innerHTML;

            const newSubtotal = doc.getElementById('CartDrawerSubtotal');
            const currentSubtotal = this.querySelector('#CartDrawerSubtotal');
            if (newSubtotal && currentSubtotal) currentSubtotal.innerHTML = newSubtotal.innerHTML;
          });
      }
    }

    customElements.define('cart-drawer', CartDrawer);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["email-popup"] && !Shopify.designMode) return;
  try {
    
    class EmailPopup extends HTMLElement {
      connectedCallback() {
        this.storageKey = 'email-popup-shown';
        this.closers = this.querySelectorAll('[data-email-popup-close]');
        this.closers.forEach((el) => el.addEventListener('click', this.close.bind(this)));
        this.addEventListener('keyup', (event) => {
          if (event.code === 'Escape') this.close();
        });

        this.countdownEl = this.querySelector('[data-email-popup-countdown]');
        this.minutesEl = this.querySelector('[data-countdown-minutes]');
        this.secondsEl = this.querySelector('[data-countdown-seconds]');

        if (sessionStorage.getItem(this.storageKey)) return;

        const delay = (parseFloat(this.dataset.delay) || 2) * 1000;
        this.timeout = setTimeout(this.open.bind(this), delay);
      }

      open() {
        this.setAttribute('data-open', '');
        document.body.style.overflow = 'hidden';
        sessionStorage.setItem(this.storageKey, 'true');
        this.startCountdown();
      }

      close() {
        clearTimeout(this.timeout);
        this.stopCountdown();
        this.removeAttribute('data-open');
        document.body.style.overflow = '';
      }

      startCountdown() {
        if (!this.countdownEl) return;
        const minutes = parseFloat(this.dataset.countdownMinutes) || 10;
        this.countdownEndsAt = Date.now() + minutes * 60 * 1000;
        this.updateCountdown();
        this.countdownInterval = setInterval(this.updateCountdown.bind(this), 1000);
      }

      stopCountdown() {
        clearInterval(this.countdownInterval);
      }

      updateCountdown() {
        const remainingMs = this.countdownEndsAt - Date.now();

        if (remainingMs <= 0) {
          this.minutesEl.textContent = '00';
          this.secondsEl.textContent = '00';
          this.stopCountdown();
          return;
        }

        const totalSeconds = Math.floor(remainingMs / 1000);
        const minutes = Math.floor(totalSeconds / 60);
        const seconds = totalSeconds % 60;

        this.minutesEl.textContent = String(minutes).padStart(2, '0');
        this.secondsEl.textContent = String(seconds).padStart(2, '0');
      }
    }

    customElements.define('email-popup', EmailPopup);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["featured-product"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('product-modal')) {
    customElements.define('product-modal', class ProductModal extends ModalDialog {
      constructor() {
        super();
      }

      hide() {
        super.hide();
      }

      show(opener) {
        super.show(opener);
        this.showActiveMedia();
      }

      showActiveMedia() {
        this.querySelectorAll(`[data-media-id]:not([data-media-id="${this.openedBy.getAttribute("data-media-id")}"])`).forEach((element) => {
            element.classList.remove('active');
          }
        )
        const activeMedia = this.querySelector(`[data-media-id="${this.openedBy.getAttribute("data-media-id")}"]`);
        const activeMediaTemplate = activeMedia.querySelector('template');
        const activeMediaContent = activeMediaTemplate ? activeMediaTemplate.content : null;
        activeMedia.classList.add('active');
        activeMedia.scrollIntoView();

        const container = this.querySelector('[role="document"]');
        container.scrollLeft = (activeMedia.width - container.clientWidth) / 2;

        if (activeMedia.nodeName == 'DEFERRED-MEDIA' && activeMediaContent && activeMediaContent.querySelector('.js-youtube'))
          activeMedia.loadContent();
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.getElementById('shopify-section-header');
      this.headerBounds = {};
      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        requestAnimationFrame(this.reset.bind(this));
      }


      this.currentScrollTop = scrollTop;
    }

    hide() {
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('details-disclosure');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  document.addEventListener('cart:refresh', async () => {
    try {
      const response = await fetch(`${window.routes.cart_url}.js`);
      const cart = await response.json();
      const bubble = document.querySelector('#cart-icon-bubble .cart-count-bubble');
      if (!bubble) return;
      const countEl = bubble.querySelector('[aria-hidden]');
      if (countEl) countEl.textContent = cart.item_count < 100 ? cart.item_count : '';
      bubble.hidden = cart.item_count === 0;
    } catch (error) {}
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-cart-footer"]) return;
  try {
    
  class CartNote extends HTMLElement {
    constructor() {
      super();

      this.addEventListener('change', debounce((event) => {
        const body = JSON.stringify({ note: event.target.value });
        fetch(`${routes.cart_update_url}`, {...fetchConfig(), ...{ body }});
      }, 300))
    }
  }

  customElements.define('cart-note', CartNote);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product"]) return;
  try {
    
  class ProductModal extends ModalDialog {
    constructor() {
      super();
    }

    hide() {
      super.hide();
    }

    show(opener) {
      super.show(opener);
      this.showActiveMedia();
    }

    showActiveMedia() {
      this.querySelectorAll(`[data-media-id]:not([data-media-id="${this.openedBy.getAttribute("data-media-id")}"])`).forEach((element) => {
          element.classList.remove('active');
        }
      )
      const activeMedia = this.querySelector(`[data-media-id="${this.openedBy.getAttribute("data-media-id")}"]`);
      const activeMediaTemplate = activeMedia.querySelector('template');
      const activeMediaContent = activeMediaTemplate ? activeMediaTemplate.content : null;
      activeMedia.classList.add('active');
      activeMedia.scrollIntoView();

      const container = this.querySelector('[role="document"]');
      container.scrollLeft = (activeMedia.width - container.clientWidth) / 2;

      if (activeMedia.nodeName == 'DEFERRED-MEDIA' && activeMediaContent && activeMediaContent.querySelector('.js-youtube'))
        activeMedia.loadContent();
    }
  }

  if (!customElements.get('product-modal')) customElements.define('product-modal', ProductModal);

  class StickyAtc extends HTMLElement {
    connectedCallback() {
      const targetId = this.dataset.watchTarget;
      const target = targetId ? document.getElementById(targetId) : null;
      this.submitButton = this.querySelector('[data-sticky-atc-submit]');

      if (this.submitButton) {
        this.submitButton.addEventListener('click', () => {
          const mainForm = document.querySelector('form[id^="product-form-"]');
          if (mainForm) {
            const submit = mainForm.querySelector('[type="submit"], button[name="add"]');
            if (submit) submit.click();
          }
        });
      }

      if (!target) return;

      this.observer = new IntersectionObserver((entries) => {
        const isInfoVisible = entries[0].isIntersecting;
        if (isInfoVisible) {
          this.removeAttribute('data-visible');
        } else {
          this.setAttribute('data-visible', '');
        }
      }, { threshold: 0 });

      this.observer.observe(target);
    }

    disconnectedCallback() {
      if (this.observer) this.observer.disconnect();
    }
  }

  if (!customElements.get('sticky-atc')) customElements.define('sticky-atc', StickyAtc);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-recommendations"]) return;
  try {
    
  class ProductRecommendations extends HTMLElement {
    constructor() {
      super();

      const handleIntersection = (entries, observer) => {
        if (!entries[0].isIntersecting) return;
        observer.unobserve(this);

        fetch(this.dataset.url)
          .then(response => response.text())
          .then(text => {
            const html = document.createElement('div');
            html.innerHTML = text;
            const recommendations = html.querySelector('product-recommendations');

            if (recommendations && recommendations.innerHTML.trim().length) {
              this.innerHTML = recommendations.innerHTML;
            }

            if (html.querySelector('.grid__item')) {
              this.classList.add('product-recommendations--loaded');
            }
          })
          .catch(e => {
            console.error(e);
          });
      }

      new IntersectionObserver(handleIntersection.bind(this), {rootMargin: '0px 0px 200px 0px'}).observe(this);
    }
  }

  customElements.define('product-recommendations', ProductRecommendations);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["social-proof"] && !Shopify.designMode) return;
  try {
    
  class SocialProofVideo extends HTMLElement {
    connectedCallback() {
      this.button = this.querySelector('.social-proof__mute-toggle');
      this.video = this.querySelector('video');
      if (!this.button || !this.video) return;

      this.button.addEventListener('click', (event) => {
        event.preventDefault();
        event.stopPropagation();
        this.video.muted = !this.video.muted;
        this.button.classList.toggle('is-unmuted', !this.video.muted);
      });
    }
  }

  customElements.define('social-proof-video', SocialProofVideo);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["urgency-bar"] && !Shopify.designMode) return;
  try {
    
  class UrgencyCountdown extends HTMLElement {
    connectedCallback() {
      const endValue = this.dataset.end;
      if (!endValue) return;

      this.endDate = new Date(endValue.replace(' ', 'T'));
      if (Number.isNaN(this.endDate.getTime())) return;

      this.countdownWrapper = this.querySelector('.urgency-bar__countdown');
      this.segments = {
        daysWrapper: this.querySelector('[data-days-wrapper]'),
        days: this.querySelector('[data-days]'),
        hours: this.querySelector('[data-hours]'),
        minutes: this.querySelector('[data-minutes]'),
        seconds: this.querySelector('[data-seconds]'),
      };

      this.tick();
      this.interval = setInterval(this.tick.bind(this), 1000);
    }

    disconnectedCallback() {
      if (this.interval) clearInterval(this.interval);
    }

    tick() {
      const diff = this.endDate.getTime() - Date.now();

      if (diff <= 0) {
        clearInterval(this.interval);
        if (this.countdownWrapper) this.countdownWrapper.hidden = true;
        return;
      }

      const days = Math.floor(diff / 86400000);
      const hours = Math.floor((diff % 86400000) / 3600000);
      const minutes = Math.floor((diff % 3600000) / 60000);
      const seconds = Math.floor((diff % 60000) / 1000);

      if (this.segments.days) this.segments.days.textContent = String(days).padStart(2, '0');
      if (this.segments.hours) this.segments.hours.textContent = String(hours).padStart(2, '0');
      if (this.segments.minutes) this.segments.minutes.textContent = String(minutes).padStart(2, '0');
      if (this.segments.seconds) this.segments.seconds.textContent = String(seconds).padStart(2, '0');
      if (this.segments.daysWrapper) this.segments.daysWrapper.hidden = days === 0;
    }
  }

  customElements.define('urgency-countdown', UrgencyCountdown);

  } catch(e) { console.error(e); }
})();
})();
